import { connect } from 'react-redux';
import App from './App';
import { appInit, appShutdown, appRenderError } from './actions/app';

const mapDispatchToProps = (dispatch, ownProps) => ({
  onInit: () =>
    dispatch(appInit(
      ownProps.rewardsContractAddress,
      ownProps.catTokenAddress,
      ownProps.catPaymentContractAddress,
      ownProps.networkName,
      ownProps.tokenList,
      ownProps.abandonCampaignCreationMessage,
      ownProps.abandonRewardsDownloadMessage,
      ownProps.appUrl,
      ownProps.supportedWallets,
    )),
  onShutdown: () => dispatch(appShutdown()),
  onError: (...args) => dispatch(appRenderError(...args)),
});

export default connect(undefined, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/AppContainer.js